import React from 'react';

export const PasteSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="66"
    height="67"
    viewBox="0 0 66 67"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M54.3965 26.4355H37.293C36.2849 26.4355 35.3182 26.836 34.6054 27.5488C33.8926 28.2616 33.4922 29.2283 33.4922 30.2363V60.6426C33.4922 61.6506 33.8926 62.6173 34.6054 63.3301C35.3182 64.0429 36.2849 64.4434 37.293 64.4434H60.0977C61.1057 64.4434 62.0724 64.0429 62.7852 63.3301C63.498 62.6173 63.8984 61.6506 63.8984 60.6426V35.9375L54.3965 26.4355Z"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.4922 26.4355V34.0371C52.4922 35.0451 52.8926 36.0119 53.6054 36.7247C54.3182 37.4375 55.2849 37.8379 56.293 37.8379H63.8945"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.9023 39.7422H41.1016"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.3047 47.3359H41.1016"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M56.3047 54.9473H41.1016"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <mask
      id="mask0_30327_865"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="3"
      width="49"
      height="55"
    >
      <path d="M0.765625 3.34375H48.2578V57.4994H0.765625V3.34375Z" fill="white" />
    </mask>
    <g mask="url(#mask0_30327_865)">
      <path
        d="M27.4767 57.4877H9.6694C7.30787 57.4877 5.04291 56.5874 3.37345 54.9842C1.70385 53.3813 0.765625 51.2071 0.765625 48.94V11.9011C0.765625 9.63407 1.70395 7.45971 3.37345 5.85703C5.04305 4.25421 7.30787 3.35352 9.6694 3.35352H39.3487C41.7096 3.35352 43.9746 4.2543 45.6441 5.85703C47.3141 7.45984 48.2519 9.63407 48.2519 11.9011V20.4489C48.2519 21.4669 47.6863 22.4075 46.7685 22.9164C45.85 23.4254 44.7184 23.4254 43.8006 22.9164C42.8821 22.4075 42.3166 21.4669 42.3166 20.4489V11.9011C42.3166 11.1456 42.0034 10.4209 41.4473 9.88639C40.8906 9.35196 40.1356 9.05188 39.3486 9.05188H9.66935C8.88235 9.05188 8.12742 9.35196 7.57065 9.88639C7.01388 10.4208 6.70136 11.1456 6.70136 11.9011V48.94C6.70136 49.6961 7.01395 50.4208 7.57065 50.9548C8.12735 51.4892 8.88231 51.7893 9.66935 51.7893H27.4766C28.537 51.7893 29.5168 52.3327 30.047 53.2139C30.5772 54.0956 30.5772 55.182 30.047 56.0631C29.5168 56.9448 28.5371 57.4877 27.4767 57.4877Z"
        fill="currentColor"
      />
    </g>
    <mask
      id="mask1_30327_865"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="15"
      y="0"
      width="19"
      height="10"
    >
      <path d="M15.6797 0.501953H33.4884V9.17581H15.6797V0.501953Z" fill="white" />
    </mask>
    <g mask="url(#mask1_30327_865)">
      <path
        d="M24.3738 9.0497C22.0668 9.0497 19.857 8.74962 18.2261 8.21519C16.5951 7.68076 15.6797 6.956 15.6797 6.20044V3.35123C15.6797 2.33327 17.3363 1.39267 20.0267 0.883689C22.7154 0.374708 26.0303 0.374708 28.7206 0.883689C31.4094 1.39267 33.0676 2.33327 33.0676 3.35123V6.20044C33.0676 6.95596 32.1519 7.68069 30.5212 8.21519C28.8905 8.74969 26.6793 9.0497 24.3738 9.0497Z"
        fill="currentColor"
      />
    </g>
    <path
      d="M33.4003 14.5684H15.593C14.806 14.5684 14.0511 14.2683 13.4943 13.7339C12.9375 13.1995 12.625 12.4747 12.625 11.7191V8.86685C12.625 7.84889 13.1905 6.9083 14.109 6.39931C15.0274 5.89033 16.1585 5.89033 17.0769 6.39931C17.9953 6.9083 18.5609 7.84889 18.5609 8.86685V8.86981H30.4327V8.86685C30.4327 7.84889 30.9982 6.9083 31.9167 6.39931C32.8346 5.89033 33.9662 5.89033 34.8846 6.39931C35.8025 6.9083 36.3686 7.84889 36.3686 8.86685V11.7191C36.3686 12.4747 36.0554 13.1994 35.4993 13.7339C34.9426 14.2683 34.1873 14.5684 33.4003 14.5684Z"
      fill="currentColor"
    />
  </svg>
);

export default PasteSvg;
